import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@unite-us/ui';
import { ProgramDetail } from '@unite-us/app-components';
import { APP_ENVIRONMENT } from '../../api/config';
export function DetailsDrawer(_ref) {
  var selectedProgram = _ref.selectedProgram,
    setSelectedProgram = _ref.setSelectedProgram;
  return /*#__PURE__*/React.createElement(Drawer, {
    className: "program-detail-drawer",
    onClose: function onClose() {
      return setSelectedProgram(undefined);
    },
    open: !!selectedProgram,
    secondary: true,
    topOffset: "60px",
    width: "500px"
  }, selectedProgram && /*#__PURE__*/React.createElement(ProgramDetail, {
    id: selectedProgram.id,
    name: selectedProgram.name,
    description: selectedProgram.description,
    eligibilityText: selectedProgram.eligibility_text,
    hasRequirements: selectedProgram.hasRequirements,
    hasAccessibility: selectedProgram.hasAccessibility,
    hasOtherEligibility: selectedProgram.hasOtherEligibility,
    hasEligibility: selectedProgram.hasEligibility,
    hasContactInfo: selectedProgram.hasContactInfo,
    postal_code_requirements: selectedProgram.postal_code_requirements,
    city_requirements: selectedProgram.city_requirements,
    county_requirements: selectedProgram.county_requirements,
    state_requirements: selectedProgram.state_requirements,
    age_requirements: selectedProgram.age_requirements,
    age_specializations: selectedProgram.age_specializations,
    gender_requirements: selectedProgram.gender_requirements,
    delivery_options: selectedProgram.delivery_options,
    population_restrictions: selectedProgram.population_restrictions,
    languages: selectedProgram.languages,
    population_specializations: selectedProgram.population_specializations,
    accessibility_options: selectedProgram.accessibility_options,
    residency: selectedProgram.residency,
    hasEligibilityText: selectedProgram.hasEligibilityText,
    transportation_options: selectedProgram.transportation_options,
    payment_options: selectedProgram.payment_options,
    services: selectedProgram.services,
    phone_numbers: selectedProgram.phone_numbers,
    email_addresses: selectedProgram.email_addresses,
    website_url: selectedProgram.website_url,
    locations: selectedProgram.locations,
    hours: selectedProgram.hours,
    receiving_referrals: selectedProgram.receiving_referrals,
    offersSpecializedScreening: selectedProgram.offersSpecializedScreening,
    provider_id: selectedProgram.provider_id,
    provider_name: selectedProgram.provider_name,
    provider_description: selectedProgram.provider_description,
    provider_phone_numbers: selectedProgram.provider_phone_numbers,
    provider_email_addresses: selectedProgram.provider_email_addresses,
    provider_website_url: selectedProgram.provider_website_url,
    provider_hours: selectedProgram.provider_hours,
    provider_licensed: selectedProgram.provider_licensed,
    provider_locations: selectedProgram.provider_locations,
    hasOrgInfo: selectedProgram.hasOrgInfo,
    latitude: selectedProgram.latitude,
    longitude: selectedProgram.longitude,
    zoom: selectedProgram.zoom,
    servingArea: selectedProgram.servingArea,
    hasMap: selectedProgram.hasMap,
    shoppingCartContext: selectedProgram.shoppingCartContext,
    providerPrograms: selectedProgram.providerPrograms,
    isSuperset: selectedProgram.isSuperset,
    uup459SupersetPhase2: selectedProgram.uup459SupersetPhase2,
    cerb1367ResourceListDetailEnhancements: selectedProgram.cerb1367ResourceListDetailEnhancements,
    scrollTo: selectedProgram.scrollTo,
    googleApiKey: APP_ENVIRONMENT.googleMapsApiKey,
    renderHeader: selectedProgram.renderHeader,
    cerbNy1115: selectedProgram.cerbNy1115,
    className: selectedProgram.className,
    address: selectedProgram.address,
    otherPrograms: selectedProgram.otherPrograms,
    fromLatitude: selectedProgram.fromLatitude,
    fromLongitude: selectedProgram.fromLongitude,
    appRoles: selectedProgram.appRoles
  }));
}
DetailsDrawer.propTypes = {
  selectedProgram: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    eligibility_text: PropTypes.string,
    hasRequirements: PropTypes.bool,
    hasAccessibility: PropTypes.bool,
    hasOtherEligibility: PropTypes.bool,
    hasEligibility: PropTypes.bool,
    hasContactInfo: PropTypes.bool,
    postal_code_requirements: PropTypes.string,
    city_requirements: PropTypes.array,
    county_requirements: PropTypes.array,
    state_requirements: PropTypes.array,
    age_requirements: PropTypes.array,
    age_specializations: PropTypes.array,
    gender_requirements: PropTypes.array,
    delivery_options: PropTypes.array,
    population_restrictions: PropTypes.array,
    languages: PropTypes.array,
    population_specializations: PropTypes.array,
    accessibility_options: PropTypes.array,
    residency: PropTypes.string,
    hasEligibilityText: PropTypes.bool,
    transportation_options: PropTypes.array,
    payment_options: PropTypes.array,
    services: PropTypes.array,
    phone_numbers: PropTypes.array,
    email_addresses: PropTypes.array,
    website_url: PropTypes.string,
    locations: PropTypes.array,
    hours: PropTypes.array,
    receiving_referrals: PropTypes.bool,
    offersSpecializedScreening: PropTypes.bool,
    provider_id: PropTypes.string,
    provider_name: PropTypes.string,
    provider_description: PropTypes.string,
    provider_phone_numbers: PropTypes.array,
    provider_email_addresses: PropTypes.array,
    provider_website_url: PropTypes.string,
    provider_hours: PropTypes.array,
    provider_licensed: PropTypes.bool,
    provider_locations: PropTypes.array,
    hasOrgInfo: PropTypes.bool,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    zoom: PropTypes.number,
    servingArea: PropTypes.string,
    hasMap: PropTypes.bool,
    shoppingCartContext: PropTypes.object,
    providerPrograms: PropTypes.array,
    isSuperset: PropTypes.bool,
    uup459SupersetPhase2: PropTypes.bool,
    cerb1367ResourceListDetailEnhancements: PropTypes.bool,
    scrollTo: PropTypes.func,
    googleApiKey: PropTypes.string,
    renderHeader: PropTypes.func,
    cerbNy1115: PropTypes.bool,
    className: PropTypes.string,
    address: PropTypes.string,
    otherPrograms: PropTypes.array,
    fromLatitude: PropTypes.number,
    fromLongitude: PropTypes.number
  }),
  setSelectedProgram: PropTypes.func.isRequired
};
DetailsDrawer.defaultProps = {
  selectedProgram: null
};
export default DetailsDrawer;
//# sourceMappingURL=DetailsDrawer.js.map